// extracted by mini-css-extract-plugin
export default {"wrapper":"nZ-z","availablePromoMessagesLabel":"oZ-z","promoMessageList":"pZ-z","promoMessage":"qZ-z","appliedPromoMessage":"rZ-z","promoMessageAmount":"sZ-z"};